import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=4b6e8ca4&"
import script from "./AlertDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AlertDialog.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6e8ca4')) {
      api.createRecord('4b6e8ca4', component.options)
    } else {
      api.reload('4b6e8ca4', component.options)
    }
    module.hot.accept("./AlertDialog.vue?vue&type=template&id=4b6e8ca4&", function () {
      api.rerender('4b6e8ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/AlertDialog.vue"
export default component.exports